// import palette from 'src/theme/palette';
// import 'src/components/styles/select.css';
// import React, { useState } from 'react';
// import { Typography } from '@mui/material';
// import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io';

// interface SelectProps {
//   placeholder?: string;
//   label?: string;
//   style?: React.CSSProperties;
//   value: string;
//   onChange: (value: string) => void;
//   options: { label: string; value: string }[];
//   helperText?: string;
//   labelStyle?: React.CSSProperties;
//   error?: boolean;
// }

// const Select: React.FC<SelectProps> = ({
//   placeholder,
//   label,
//   style,
//   value,
//   onChange,
//   options,
//   helperText,
//   labelStyle,
//   error,
// }) => {
//   const [isOpen, setIsOpen] = useState(false);
//   const [selectedOption, setSelectedOption] = useState({ label: value, value: value });
//   const toggleDropdown = () => setIsOpen(!isOpen);

//   const handleOptionSelect = (option) => {
//     setSelectedOption(option);
//     setIsOpen(false);
//     onChange(option.value);
//   };

//   return (
//     <div
//       style={{
//         display: 'flex',
//         flexDirection: 'column',
//       }}
//     >
//       {label && <label className="_input_label" style={{...labelStyle}}>{label}</label>}

//       <div className="custom-dropdown" onClick={toggleDropdown}>
//         <div
//           className="_dropdown"
//           style={{
//             color: selectedOption.value === '' ? palette.grey[500] : palette.grey[800],
//             display: 'flex',
//             flex: 1,
//             ...style,
//             backgroundColor: palette.grey[400],
//             borderColor: isOpen ? palette.primary.light : error ? palette.error.main : palette.grey[400],
//           }}
//         >
//           <span className="_selected_value">
//             {selectedOption.label || placeholder}
//           </span>

//           {!isOpen ? <IoIosArrowDown color="#A0AEC0" /> : <IoIosArrowUp color="#A0AEC0" />}
//         </div>
//         {helperText && (
//           <Typography variant="body2" color={error ? "error" : "textSecondary"} style={{ marginTop: 5 }}>
//             {helperText}
//           </Typography>
//         )}
//         {isOpen && (
//           <div className="dropdown-options">
//             {options.map((option, i) => (
//               <Typography
//                 variant="body2"
//                 className="option"
//                 key={i}
//                 onClick={() => handleOptionSelect(option)}
//               >
//                 {option.label}
//               </Typography>
//             ))}
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export { Select };

import React from 'react';
import { FormControl, Select as MuiSelect, MenuItem, Typography, OutlinedInput } from '@mui/material';
import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io';
import palette from 'src/theme/palette';

interface CustomSelectProps {
  placeholder?: string;
  firstItem?: string;
  label?: string;
  value: string | null;
  onChange: (value: string) => void;
  options: { label: string; value: string }[];
  helperText?: string;
  error?: boolean;
  labelStyle?: React.CSSProperties;
}

const Select: React.FC<CustomSelectProps> = ({
  placeholder = 'Select an option',
  firstItem,
  label,
  value,
  onChange,
  options,
  helperText,
  error = false,
  labelStyle,
}) => {
  return (
    <div>
      {/* {label && (
        <Typography variant="body2" color="textSecondary" style={{ marginBottom: '4px' }}>
          {label}
        </Typography>
      )} */}
      {label && <div className="_input_label">{label}</div>}
      <FormControl fullWidth error={error} style={{ backgroundColor: palette.grey[400], borderRadius: 12 }}>
        <MuiSelect
          value={value}
          onChange={(e) => onChange(e.target.value)}
          displayEmpty
          sx={{
            height: 55,
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: 'transparent',
              legend: {
                display: 'none',
              },
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: 'transparent',
              borderRadius: 1.5,
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              border: `1px solid ${palette.primary.main}`,
              borderRadius: 1.5,
              height: 57,
              marginTop: 0.5,
            },
            '& .MuiSelect-select': {
              paddingLeft: '16px',
              borderRadius: 1.5,
            },
          }}
          // input={
          //   <OutlinedInput
          //     sx={{
          //       height: 55,
          //       backgroundColor: palette.grey[200],
          //       borderRadius: '12px',
          //       border: '1px solid #ebedf0',
          //       '& fieldset': {
          //         border: 'none',
          //       },
          //       '&.Mui-focused': {
          //         border: `1px solid ${palette.primary.main}`,
          //         outline: 'none',
          //         '& fieldset': {
          //           border: 'none',
          //         },
          //       },
          //       '& .MuiSelect-select': {
          //         paddingY: '14px',
          //         paddingLeft: '16px',
          //         color: palette.text.primary,
          //         '&:focus': {
          //           backgroundColor: 'transparent',
          //         },
          //       },
          //     }}
          //     endAdornment={value ? <IoIosArrowUp color="#A0AEC0" /> : <IoIosArrowDown color="#A0AEC0" />}
          //   />
          // }
          renderValue={(selected) => {
            if (!selected) {
              return <Typography color="text.secondary">{placeholder}</Typography>;
            }
            return options.find((option) => option.value === selected)?.label;
          }}
        >
          {firstItem && (
            <MenuItem value="">
              <em>{firstItem}</em>
            </MenuItem>
          )}
          {options.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </MuiSelect>
      </FormControl>
      {helperText && (
        <Typography variant="body2" color={error ? 'error' : 'textSecondary'} style={{ marginTop: 5 }}>
          {helperText}
        </Typography>
      )}
    </div>
  );
};

export default Select;
